export const isValidDayOf = (d, m, y) => {
  const MONTHS_30 = [9, 4, 6, 11];
  const MONTHS_31 = [1, 3, 5, 7, 8, 9, 10, 12];
  const isLeapYear = y ? !(y % 4) : false;
  if (d === 0 || m === 0 || y === 0) return false;
  if (d < 1) return false;
  if (d > 31) return false;
  if (MONTHS_30.includes(m) && d > 30) return false;
  if (MONTHS_31.includes(m) && d > 31) return false;
  if (m === 2 && isLeapYear && d > 29) return false;
  if (m === 2 && !isLeapYear && d > 28) return false;
  return true;
};

export const isValidMonth = (m) => {
  if (m < 1) return false;
  if (m > 12) return false;
  return true;
};

export const prepareQueryString = (params) => {
  const result = new URLSearchParams();
  if (params) {
    Object.keys(params).forEach((k) => {
      result.set(k, params[k]);
    });
  }
  return result.toString();
};

export const updateURLParamsWithTimeStamp = (params, timestamp = true) => {
  const result = new URLSearchParams();
  if (params) {
    Object.keys(params).forEach((k) => {
      result.set(k, params[k]);
    });
  }
  if (timestamp) {
    result.set('t', `${new Date().getTime()}`);
  }
  return result.toString();
};

export const extractErrorMsg = (resBody, allErrors = false) => {
  const defaultErrorMsg = 'Unknown error occurred, please try again';

  if (!resBody) {
    return defaultErrorMsg;
  }

  // Support old plain error message
  if (resBody.message) {
    return resBody.message;
  }

  const errors = resBody.errors?.map(e => e.message || '');
  if (errors && errors.length > 0) {
    return !allErrors ? errors[0] : errors.join('\r\n');
  }

  return defaultErrorMsg;
};
